import { defineComponent as _defineComponent } from 'vue'
import MyProjectsContractEditHeadline from '@/views/my-projects/components/contract/MyProjectsContractEditHeadline.vue';
import { useToggle } from '@vueuse/core';
import MyProjectsContractBaseAddress from '@/views/my-projects/components/contract/base-data/MyProjectsContractBaseAddress.vue';
import useContract from '@/views/my-projects/composables/useContract';
import { computed, ref, watchEffect } from 'vue';
import { ContractUpdateAddress } from '@/models/Contracts';
import useUser from '@/mixins/useUser';
import { updateContractAddress } from '@/services/ContractService';
import TranslatedBackendErrors from '@/utils/TranslatedBackendErrors';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractBaseDataPartner',
  setup(__props) {

const [isEditing, toggleEdit] = useToggle(false);
const {
  contractDetail,
  isUserClient,
  isUserContractor,
  contractorData,
  clientData,
  isContractStatusOpen
} = useContract();

const localClientData = ref({ ...clientData.value });
const localContractorData = ref({ ...contractorData.value });

const isContractorEditing = computed({
  get: () => isEditing.value && isUserContractor.value,
  set: (value: boolean) => {
    if (contractDetail.value?.contractor) {
      isEditing.value = value;
    }
  }
});
const isClientEditing = computed({
  get: () => isEditing.value && isUserClient.value,
  set: (value: boolean) => {
    if (contractDetail.value?.client) {
      isEditing.value = value;
    }
  }
});

const clientName = computed(() => contractDetail.value?.client?.company?.name ?? useUser(contractDetail.value?.client.user ?? 'self').displayName.value ?? '');

const contractorName = computed(() => contractDetail.value?.contractor?.company?.name ?? useUser(contractDetail.value?.contractor?.user ?? 'self').displayName.value ?? '');

const saveAddress = async (data: ContractUpdateAddress) => {
  if (contractDetail.value?.contractId) {
    try {
      await updateContractAddress(contractDetail.value?.contractId, data);
      isEditing.value = false;
      if (isUserClient.value) {
        clientData.value = data;
        isClientEditing.value = false;
      } else {
        contractorData.value = data;
        isContractorEditing.value = false;
      }
    } catch (e: any) {
      const translatedError = new TranslatedBackendErrors(e.response);
      translatedError.outputGlobalErrorMessage('MyProjectsContractBaseDataPartner.vue');
      if (isUserClient.value) {
        isClientEditing.value = true;
      } else {
        isContractorEditing.value = true;
      }
    }
  }
};

// In the event of an abort, the old memory statuses are restored
const addressProcessingAbort = () => {
  localClientData.value = { ...clientData.value };
  localContractorData.value = { ...contractorData.value };
};

// If reactive data changes, it is updated
watchEffect(() => {
  localClientData.value = { ...clientData.value };
  localContractorData.value = { ...contractorData.value };
});


return { __sfc: true,isEditing, toggleEdit, contractDetail, isUserClient, isUserContractor, contractorData, clientData, isContractStatusOpen, localClientData, localContractorData, isContractorEditing, isClientEditing, clientName, contractorName, saveAddress, addressProcessingAbort, MyProjectsContractEditHeadline, MyProjectsContractBaseAddress }
}

})